export const FETCH_NODE_GROUPS = "FETCH_NODE_GROUPS";
export const FETCH_NODE_GROUPS_FULFILLED = "FETCH_NODE_GROUPS_FULFILLED";
export const FETCH_NODE_GROUPS_REJECTED = "FETCH_NODE_GROUPS_REJECTED";
export const ADD_GROUP_FULFILLED = "ADD_GROUP_FULFILLED";
export const UPDATE_GROUP_FULFILLED = "UPDATE_GROUP_FULFILLED";
export const DELETE_TRIGGER_GROUP = "DELETE_TRIGGER_GROUP";
export const INIT_BOT_FULFILLED = "INIT_BOT_FULFILLED";

// Trigger actions
export const FETCH_NODE_GROUP_TRIGGERS = "FETCH_NODE_GROUP_TRIGGERS";
export const FETCH_NODE_GROUP_TRIGGERS_FULFILLED = "FETCH_NODE_GROUP_TRIGGERS_FULFILLED";
export const FETCH_NODE_GROUP_TRIGGERS_REJECTED = "FETCH_NODE_GROUP_TRIGGERS_REJECTED";

// Trigger response actions
export const FETCH_TRIGGER_RESPONSE = "FETCH_TRIGGER_RESPONSE";
export const FETCH_TRIGGER_RESPONSE_FULFILLED = "FETCH_TRIGGER_RESPONSE_FULFILLED";
export const FETCH_TRIGGER_RESPONSE_REJECTED = "FETCH_TRIGGER_RESPONSE_REJECTED";
export const UPDATE_TRIGGER_NAME = "UPDATE_TRIGGER_NAME";
export const UPDATE_TRIGGER_TYPE = "UPDATE_TRIGGER_TYPE";

// Add new trigger callback
export const ADD_TRIGGER_FULFILLED = "ADD_TRIGGER_FULFILLED";
export const ADD_TRIGGER_RESPONSE = "ADD_TRIGGER_RESPONSE";
export const HANDLE_CONTENT_CHANGE = "HANDLE_CONTENT_CHANGE";
export const SAVE_TRIGGER = "SAVE_TRIGGER";
export const REMOVE_TRIGGER = "REMOVE_TRIGGER";
export const CANCEL_TRIGGER = "CANCEL_TRIGGER";
export const UPDATE_TRIGGER_EVENT = "UPDATE_TRIGGER_EVENT";
export const ADD_TRIGGER_EVENT_FULFILLED = "ADD_TRIGGER_EVENT_FULFILLED";
export const DELETE_TRIGGER_EVENT = "DELETE_TRIGGER_EVENT";
export const HANDLE_ADD_QUICK_REPLY = "HANDLE_ADD_QUICK_REPLY";
export const HANDLE_ADD_QUICK_REPLY_REMOVE = "HANDLE_ADD_QUICK_REPLY_REMOVE";
export const REMOVE_TRIGGER_RESPONSE = "REMOVE_TRIGGER_RESPONSE";
export const ADD_PAYLOAD_TRIGGERS_FULFILLED = "ADD_PAYLOAD_TRIGGERS_FULFILLED";
export const UPDATE_PAYLOADS_FULFILLED = "UPDATE_PAYLOADS_FULFILLED";
export const SET_DEFAULT_TRIGGER = "SET_DEFAULT_TRIGGER";
export const ADD_SUBELEMENT = "ADD_SUBELEMENT";
export const REMOVE_SUBELEMENT = "REMOVE_SUBELEMENT";
export const MOVE_UP_SUBELEMENT = "MOVE_UP_SUBELEMENT";
export const MOVE_DOWN_SUBELEMENT = "MOVE_DOWN_SUBELEMENT";
export const SET_DEFAULT_UNKNOWN_TRIGGER = "SET_DEFAULT_UNKNOWN_TRIGGER";
export const SET_AS_ARGUMENT_TRIGGER = "SET_AS_ARGUMENT_TRIGGER";
export const SET_DEFAULT_UNKNOWN_BTN_TRIGGER = "SET_DEFAULT_UNKNOWN_BTN_TRIGGER";
export const SET_DEFAULT_ALWAYS_TRIGGER = "SET_DEFAULT_ALWAYS_TRIGGER";
export const SET_IN_PROGRESS_TRIGGER = "SET_IN_PROGRESS_TRIGGER";

export const INIT_BOT_ARGUMENTS_FULFILLED = "INIT_BOT_ARGUMENTS_FULFILLED";
export const INIT_BOT_ARGUMENTS_REJECTED = "INIT_BOT_ARGUMENTS_REJECTED";

export const LOAD_USE_CASES_TRIGGER_FULFILLED = "LOAD_USE_CASES_TRIGGER_FULFILLED";

export const INIT_BOT_REST_API_METHODS = "INIT_BOT_REST_API_METHODS";

export const SET_GROUP_TRIGGER_EVENT = "SET_GROUP_TRIGGER_EVENT";

export const MOVE_UP = "MOVE_UP";
export const MOVE_DOWN = "MOVE_DOWN";
export const LOAD_TEMPLATE_FULFILLED = "LOAD_TEMPLATE_FULFILLED";
export const SAVE_TEMPLATE_FULFILLED = "SAVE_TEMPLATE_FULFILLED";
export const SAVE_EVENT_TEMPLATE_FULFILLED = "SAVE_EVENT_TEMPLATE_FULFILLED";
export const LOAD_EVENT_TEMPLATE_FULFILLED = "LOAD_EVENT_TEMPLATE_FULFILLED";
export const SET_TRIGGER_POSITON = "SET_TRIGGER_POSITON";
